import React from "react";
import "../Sponsor/sponsorcard.css";
import Sponsor from "./sponsorprops";
import SponsorLogo from "../../../atrimages/onineimg/sponsorslogo.png";
import Sponsor1 from "../../../atrimages/sponsors/chalo.png";
import Sponsor2 from "../../../atrimages/sponsors/dsl.png";
import Sponsor3 from "../../../atrimages/sponsors/sakshi.png";
import Sponsor4 from "../../../atrimages/sponsors/akruti.PNG";
import Sponsor5 from "../../../atrimages/sponsors/manac.PNG";

export default function SponsorCard() {
  return (
    <>
      <div className="AllSponsors">
        <img src={SponsorLogo} alt="sponsoriocn" className="sposorpnglogo" />
        <br />
        <br />
        <Sponsor image={Sponsor1} />
        <Sponsor image={Sponsor3} />
        <Sponsor image={Sponsor4} />
        <Sponsor image={Sponsor5} />
        <Sponsor image={Sponsor2} />
        <br />
        <br />
        <button className="sponsor-btn">Sponsor Us</button>
      </div>
      <br />
    </>
  );
}
